// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1LVPI","toast__body":"styles_toast__body__2IJuy","toast__bodyText":"styles_toast__bodyText__1Nznw"};